import { useEffect, useState } from "react";
import { fetchConfig } from "../utils/fetchConfig";

export const useConfigLoader = () => {
  const [config, setConfig] = useState<any>(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const newConfig = await fetchConfig();
        if (isMounted) {
          setConfig(newConfig);
        }
      } catch (error) {
        console.error("Config fetch failed, retrying in 5s:", error);
        if (isMounted) {
          setTimeout(load, 5000); // 🔁 Retry ONLY if config is not loaded
        }
      }
    };

    load(); // 🔥 Try loading immediately

    return () => {
      isMounted = false;
    };
  }, []); // ✅ Runs only once

  return config;
};
